import { root } from "../services/Globals"

export default event => root.dispatchEvent(new Event(event))
